import { useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { Button } from '@frontend/components';

import { IntegerInput } from 'components/lib2/TextInput';

import { trim } from 'utils/stringUtils';

import SharedLoginLayout from '../components/SharedLoginLayout';
import { twoFactorLogin } from './data/actions';
import {
  getError,
  getHasReceivedCredentials,
  getIsLoggingIn,
} from './data/reducer';

const ButtonWrapper = styled.div`
  margin-top: 20px;
  text-align: center;
  width: 100%;
`;

const CodeInputWrapper = styled.div`
  margin-top: 20px;
  text-align: center;
  width: 100%;
  > div {
    width: 200px;
    > input[type='text'] {
      font-size: 35px;
      height: 60px;
      text-align: center;
    }
  }
`;

const Error = styled.p`
  color: #ff4136;
  font-size: 0.8125rem;
  margin: 15px 0;
  max-width: 300px;
  text-align: center;
`;

const Message = styled.label`
  font-size: 16px;
`;

const Wrapper = styled.div`
  margin: 0 0 2rem;
  @media (min-width: 600px) {
    display: flex;
    justify-content: center;
    margin: 1rem 0;
  }
  h2 {
    margin-bottom: 1rem;
    font-size: 28px;
    font-weight: 400;
  }
`;

const InsideWrapper = styled.div`
  align-items: center;
  border: 2px solid #f0f0f0;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  min-width: 360px;
  padding: 25px;
`;

const connector = connect(
  (state) => ({
    error: getError(state),
    hasReceivedCredentials: getHasReceivedCredentials(state),
    isLoggingIn: getIsLoggingIn(state),
  }),
  {
    login: twoFactorLogin.request,
  },
);

export const TwoFactorAuthentication = ({
  error,
  hasReceivedCredentials,
  isLoggingIn,
  login,
}) => {
  const [token, setToken] = useState(undefined);

  const handleSubmit = (e) => {
    e.preventDefault();

    login({ token });
  };

  return (
    <SharedLoginLayout>
      <Wrapper>
        <InsideWrapper>
          <img
            alt="password_icon"
            src={
              'https://s3.amazonaws.com/static.paperlessparts.com/images/password-icon.png'
            }
            width="200"
          />
          <form onSubmit={handleSubmit}>
            <Message>Please enter your 2FA code to complete sign-in.</Message>
            <CodeInputWrapper>
              <IntegerInput
                maxLength={6}
                value={token}
                onChange={(e) => setToken(e.target.value)}
                placeholder={'123456'}
                disabled={!hasReceivedCredentials}
              />
            </CodeInputWrapper>
            <ButtonWrapper>
              <Button
                buttonType="primary"
                type="submit"
                isDisabled={
                  !hasReceivedCredentials || !token || token.length < 6
                }
                loading={isLoggingIn}
              >
                Submit
              </Button>
            </ButtonWrapper>
          </form>
          {error && <Error role="alert">{trim(error, 300)}</Error>}
        </InsideWrapper>
      </Wrapper>
    </SharedLoginLayout>
  );
};

export default connector(TwoFactorAuthentication);
